/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModMessageContainer_viewer = {
    readonly status: {
        readonly modMessage: {
            readonly active: boolean;
            readonly message: string | null;
        };
    };
    readonly " $refType": "ModMessageContainer_viewer";
};
export type ModMessageContainer_viewer$data = ModMessageContainer_viewer;
export type ModMessageContainer_viewer$key = {
    readonly " $data"?: ModMessageContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModMessageContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModMessageContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModMessageStatus",
                    "kind": "LinkedField",
                    "name": "modMessage",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'f7bafb93b3e161627106f1405505ba26';
export default node;
